/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Falcon document type dictionary
 */
export enum FalconDocumentType {
  Invoice = "WZ",
  Assignation = "DD",
  InvoiceCorrection = "ZW"
}
